import angular from 'angular'
import { stateAnalysis } from 'redevConfig'
const list = (stateAnalysis && stateAnalysis.list) || ''

const stateAnalysisList = list ? require(`redevelopment/statistics/stateAnalysis/${list.templateName}`) : require('./view/stateAnalysis.html')
const stateAnalysisListCtrl = list ? require(`redevelopment/statistics/stateAnalysis/${list.controllerName}`) : require('./stateAnalysisCtrl.js')
export default angular
    .module('statistics.chartAnalysis.stateAnalysis', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.chartAnalysis.stateAnalysis', {
            url: '/stateAnalysis',
            abstract: true,
            template: '<div ui-view></div>',
            title: '状态分析',
            default: 'statistics.chartAnalysis.stateAnalysis.list',
        })
        $stateProvider.state('statistics.chartAnalysis.stateAnalysis.list', {
            url: '/list',
            template: stateAnalysisList,
            controller: 'stateAnalysisListCtrl',
        })
    }])
    .controller('stateAnalysisListCtrl', stateAnalysisListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/stateAnalysis/index.js